/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastchangeonjahrgangsstufebyuser5Inputs */

const de__field_lastchangeonjahrgangsstufebyuser5 = /** @type {(inputs: _Field_Lastchangeonjahrgangsstufebyuser5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`letzte Änderung Jahrgangsstufe von`)
};

/**

* @param {_Field_Lastchangeonjahrgangsstufebyuser5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastchangeonjahrgangsstufebyuser5 = /** @type {((inputs?: _Field_Lastchangeonjahrgangsstufebyuser5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastchangeonjahrgangsstufebyuser5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastchangeonjahrgangsstufebyuser5(inputs)
});
export { _field_lastchangeonjahrgangsstufebyuser5 as "_field_lastChangeOnJahrgangsstufeByUser" }